// extracted by mini-css-extract-plugin
export var aside = "AsideRoot-module--aside--YDZne";
export var fullWidth = "AsideRoot-module--fullWidth--YmAgX";
export var overlay = "AsideRoot-module--overlay--pCJeW";